import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoMoneyInputOutlined, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ProductVariantBasicInfo({variantId}) {


    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const [variantTitle, setVariantTitle] = useState("");
    const [weight, setWeight] = useState(0);
    const [price, setPrice] = useState(0);
    const [compareAtPrice, setCompareAtPrice] = useState(0);
    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");
    const [updatedBy, setUpdatedBy] = useState("");

    const service = new ProductVariantService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined'){
            getProductVariantBasicInfoFromServer()
        }
    }, [variantId]);

    function getProductVariantBasicInfoFromServer() {
        loading.show()
        service.getProductVariantInfo(variantId)
            .then(response => {
                setVariantTitle(response.title ? response.title : "")
                setWeight(response.weight ? response.weight : "")
                setPrice(response.price ? response.price : "")
                setCompareAtPrice(response.compareAtPrice ? response.compareAtPrice : "")
                setCreatedAt(response.createdAt ? convertUniversalDateTimeToPersianDateTime(response.createdAt) : "")
                setCreatedBy(response.createdBy ? response.createdBy : "")
                setUpdatedAt(response.updatedAt ? convertUniversalDateTimeToPersianDateTime(response.updatedAt) : "")
                setUpdatedBy(response.updatedBy ? response.updatedBy : "")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductVariantBasicInfo() {
        setActionButtonLoading(true)
        service.updateProductVariantInfo(
            variantId,
            variantTitle,
            price,
            compareAtPrice,
            weight
        ).then(response=>{
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            setActionButtonLoading(false)
        })
    }

    return (
        <>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasActionButton
                        actionButtonTitle={"بروزرسانی"}
                        actionButtonLoadingState={actionButtonLoading}
                        actionButtonOnclickWithValidation={handleUpdateProductVariantBasicInfo}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان"}
                                value={variantTitle}
                                setValue={setVariantTitle}
                                required
                            />
                            <RaikoNumberInputOutlined
                                labelText={"وزن (گرم)"}
                                value={weight}
                                setValue={setWeight}
                                required
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"قیمت"}
                                value={price}
                                setValue={setPrice}
                                required
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"قیمت"}
                                value={compareAtPrice}
                                setValue={setCompareAtPrice}
                                required
                            />
                        </RaikoGridTwoColumn>

                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

                <RaikoCreatorInfo
                    createdBy={createdBy}
                    createdAt={createdAt}
                />
                <RaikoCreatorInfo
                    title={"آخرین بروزرسانی"}
                    createdBy={updatedBy}
                    createdByTitle={"ادمین"}
                    createdAt={updatedAt}
                    createdAtTitle={"تاریخ بروزرسانی"}
                />

            </RaikoGridOneColumn>
        </>
    )
}